export default __webpack_public_path__ + "static/media/info.f4b02168.png";